export default "__VITE_ASSET__Bl9bYqrE__"